<script>
import Swal from "sweetalert2";
import ApiSectionForm from "@/components/widgets/apisectionform.vue";
import SectionList from "@/components/widgets/api-section-list.vue";

export default {
    components: {
        ApiSectionForm,
        SectionList,
    },
    data() {
        return {
            tableData: [],
            loading: false,
            addNew: false,
        }
    },
    methods: {
        async fetchData() {
            this.loading = true;
            await this.getData();
            this.loading = false;
        },
        async getData() {
            try{
                const { data: response } = await this.$store.dispatch("apisection/GetApiSections");
                if(response.error){
                    return this.showToast(response.errorMessage, 'error');
                }
                response.map(item => {
                    item.edit = false;
                    item.viewGroups = false;
                    item.addGroup = false;
                    item.groupLoading = false;
                    item.groups = [];
                });
                this.tableData = response.sort((a, b) => a.sort - b.sort);
            }catch (error) {
                this.showToast('Something went wrong', 'error');
            }
        },
        async saveSection(modalData) {
            try {
                if(modalData.id == 0){
                    let sort = this.tableData.sort((a, b) => a.sort - b.sort);
                    modalData.sort = sort.length > 0 ? parseInt(sort[sort.length - 1].sort) + 1 : 1;
                    const { data: response } = await this.$store.dispatch("apisection/CreateApiSection", modalData);
                    if(response.error){
                        return this.showToast(response.errorMessage, 'error');
                    }
                    response.edit = false;
                    response.viewGroups = false;
                    response.addGroup = false;
                    response.groupLoading = false;
                    response.groups = [];
                    this.tableData.push(response);
                    this.showToast('API Section created successfully', 'success');
                }else{
                    const { data: response } = await this.$store.dispatch("apisection/UpdateApiSection", modalData);
                    if(response.error){
                        return this.showToast(response.errorMessage, 'error');
                    }
                    const index = this.tableData.findIndex(item => item.id === modalData.id);
                    modalData.edit = false;
                    if (index !== -1) {
                        this.tableData.splice(index, 1, modalData);
                    }
                    this.showToast('API Section updated successfully', 'success');
                }
            } catch (error) {
                this.showToast('Something went wrong', 'error');
            } finally {
                this.addNew = false;
            }
        },
        deleteSection(sectionId) {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const { data: response } = await this.$store.dispatch("apisection/DeleteApiSection", sectionId);
                        if(response.error){
                            return this.showToast(response.errorMessage, 'error');
                        }
                        this.tableData = this.tableData.filter(item => item.id !== sectionId);
                        this.showToast('API Section deleted successfully', 'success');
                    } catch (error) {
                        this.showToast('Something went wrong', 'error');
                    }
                }
            });
        },
    },
}
</script>
<template>
    <section>
        <div class="card border">
            <div class="card-body">
                <div
                    class="
                        d-flex
                        justify-content-between
                        align-items-center
                        mb-4
                    "
                >
                    <h4 class="card-title m-0">Api Section List</h4>
                </div>
                <template v-if="loading">
                    <div class="text-center py-3">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </template>
                <template v-if="tableData.length">
                    <div v-for="x in tableData" :key="x.id">
                        <SectionList 
                            :data="x"
                            @update="saveSection"
                            @delete="deleteSection"
                        />
                    </div>
                </template>
                <template v-else>
                    <div class="text-center py-3">
                        <p class="mb-0">No API sections found.</p>
                    </div>
                </template>
                <div class="border-dashed-img position-relative cursor-pointer rounded mt-3">
                    <template v-if="addNew">
                        <div class="p-5">
                            <ApiSectionForm 
                                @submit="saveSection"
                                @cancel="addNew = false"
                            />
                        </div>
                    </template>
                    <template v-else>
                        <h4 class="mb-0 d-flex gap-1 justify-content-center p-4" @click="addNew = true"><i class="bx bx-plus font-size-20"></i>Add New API Section</h4>
                    </template>
                </div>
            </div>
        </div>
    </section>
</template>